
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import styles from './ConnectPop.module.css';
import pageStylePops from './pageStylePops.module.css';
import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import {
    theMenuItems
} from '../FAKEDB/fakes'
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import MyFunctions from '../Functions/MyFunctions';
import SixDigitInput from '../ForAllComponents/SixDigitInput';
import WelcomBackPop from './WelcomBackPop';
import PopUpClearComp from './PopUpClearComp';
import utilsCodes from '../Connections/_Utils/utilsCodes';
import { UserContext } from '../Contexts/User_Context';

const RegisterCodeCheck = (props) => {

    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);

    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();
    const [erMsg, setErMsg] = useState("");
    const [digits, setDigits] = useState("");
    const [thePopUp, setThePopUp] = useState();


    useEffect(() => {
    }, [mobiOrNot]);

    useEffect(() => {


    }, [])

    useEffect(() => {

    }, [])



    const setTheDigist = (digitsVals) => {
        let tampoDigs = "";
        for (let i = digitsVals.length - 1; i >= 0; i--) {

            tampoDigs += digitsVals[i]
        }
        setDigits(tampoDigs);
    }



    const goCheckTheCode = async () => {
        let validatoring = "";
        setErMsg("")
        validatoring = digits.length === 6 ? "" : "יש להזין את הקוד שהתקבל"

        if (validatoring == "") {
            let codeReply = await utilsCodes.checkCode(props.codeReply.nId, {
                codeCheck: digits,
                newUsr: props.newUsr
            });

            if (codeReply.errMsg === "" || codeReply.errMsg !== undefined) {
                if (codeReply.errMsg !== 'Created') {
                    setErMsg(codeReply.errMsg)
                }
                else {
                    localStorage.setItem("napoUsrToken", codeReply.token);
                    UserEffectFunction();

                    setThePopUp(
                        <PopUpClearComp BtnTxt={"סגור"}
                            title={""}
                            noCloseBtn={true}
                            noLineStart={true}
                            btnFStyle={"fatInBtn"}
                            closePop={() => setThePopUp()}
                            parentCLose={() => props.parentCLose()}
                            theInsideComp={
                                <WelcomBackPop
                                    backFunc={true}
                                    theHelloTxt={"שמחים שהצטרפת אלינו"}
                                    closeMeFuc={() => props.parentCLose()}
                                    parentCLose={() => props.parentCLose()}
                                    shoTopStrp={(tf) => { }}
                                    scrollToTop={(stUp) => { }}
                                    connectWithNumber={() => { setThePopUp(); }}
                                />
                            } />)
                }

            }
        }
        else {
            setErMsg(validatoring)
        }
    }


    return (
        <>
            <div className={`${pageStylePops.topPlace} regularPoint`}>
                <p className={`${pageStylePops.headBig} fullRow`}>אימות באמצעות SMS</p>
                <span className={`${pageStylePops.secondHead} inColorgoldLine`}>נשלח אליך כרגע קוד אימות</span>
                <br />
                <span className={`${pageStylePops.secondHead} inColorgoldLine`}>נא להזין את הקוד</span>
            </div>

            <div className={`${pageStylePops.mainWrap}`}>

                <SixDigitInput setTheDigist={(digs) => setTheDigist(digs)} />

                {/* <div className={pageStylePops.contWrap}>
                    <div className={"noDecoration"}>שלח לי שוב</div>
                </div> */}
                <div className={pageStylePops.contWrap}>
                    <div className={pageStylePops.btnGo}>
                        <button className={`${pageStylePops.contactGo} pointing`} value="אימות"
                            onClick={() => goCheckTheCode()} >אימות</button>
                    </div>
                    <div className={"fullRow errorLine"}>
                        <p>{parse(erMsg)}</p>
                    </div>

                </div>
                <div className={pageStylePops.contWrap}>
                    <div className={"noDecoration pointing linkMe"} onClick={() => props.closeMeFuc()}>שלח לי שוב</div>
                </div>
            </div>
            {thePopUp}
        </>

    );
}

export default RegisterCodeCheck;
